<template lang="pug">
    .header.text-center
        b-progress(:value="progressCurrent", :max="progressMax", variant="dark")
        a.btn-back.pt-3.text-dark(v-if="!noBack", @click="$emit('backSignal')")
          i.fa.fa-caret-left
        router-link.btn-exit.pt-3.text-dark(v-if="fromUrl", :to="fromUrl")
          i.fa.fa-times
        router-link.btn-exit.pt-3.text-dark(v-else="", :to="{ name: 'home'}")
          i.fa.fa-times
        img.icon.mt-3(src="@/assets/images/branding/logo_dark.svg", alt="Wall collective logo")
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'AppHeader',
  props: [
    'title', 'noBack', 'progressCurrent', 'progressMax',
  ],
  data() {
    return {

    };
  },
  computed: {
    ...mapState('account', ['account', 'toUrl', 'fromUrl']),
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
  .header{
    height: $app-header-height;
    // height: $event-header-heigt;
    z-index: -10;
    // background-color: $primary;
    padding: 5px;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    color: white;
    // border-radius: 0 0 -20% 20%;
    @include desktop{
      border-radius: 0;
    }
    .icon {
      width: 100px;
    }
    h1{
      margin: 5px;
      color: rgba(black, 0.9);
    }
    .progress {
      z-index: 10000;;
      position: absolute;
      left: 0;
      bottom: 0px;
      height: 7px;
      width: 100%;
      border-radius: 0;
    }
    .btn-exit{
      position: absolute;
      right: 20px;
    }
    .btn-back{
      position: absolute;
      left: 20px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/widgets/AppHeader.vue